// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"216":"pythonlab","257":"weblab2"}[chunkId] || chunkId) + "wp" + {"5":"67094b0d03b1fbff9b95","6":"4e5eda7e952d0b9aea49","216":"8b5baca387f25dd38307","257":"bcc7413736f5bee6cc0d","260":"6f3991d8688d9fbbcea1","262":"7adb5d424fe346390eb4","263":"7a0abbfb82c4471a9485","264":"4bad027557545f7821b7"}[chunkId] + ".min.js";
};